module.exports = __webpack_public_path__ + "img/racecourse-durbanville-turf-1400.cfd6e797.svg";